/**
 * TypingIndicator — animated dots shown while the assistant is thinking.
 * Renders as a small "bubble" with three pulsing dots.
 */
import { cn } from '@/lib/utils'

export interface TypingIndicatorProps {
  /** Optional label shown beside the dots */
  label?: string
  /** Additional CSS classes */
  className?: string
}

export function TypingIndicator({ label, className }: TypingIndicatorProps) {
  return (
    <div
      role="status"
      aria-label="Assistant is thinking"
      className={cn(
        'flex items-center gap-2 text-muted-foreground text-sm',
        className
      )}
    >
      <span className="inline-flex items-center gap-1">
        <span className="h-1.5 w-1.5 rounded-full bg-primary/60 animate-[typing_1.4s_ease-in-out_infinite]" />
        <span className="h-1.5 w-1.5 rounded-full bg-primary/60 animate-[typing_1.4s_ease-in-out_0.2s_infinite]" />
        <span className="h-1.5 w-1.5 rounded-full bg-primary/60 animate-[typing_1.4s_ease-in-out_0.4s_infinite]" />
      </span>
      {label && <span className="text-xs">{label}</span>}
    </div>
  )
}
